/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimGuaranteeCode } from './ClaimGuaranteeCode';
import {
    ClaimGuaranteeCodeFromJSON,
    ClaimGuaranteeCodeFromJSONTyped,
    ClaimGuaranteeCodeToJSON,
    ClaimGuaranteeCodeToJSONTyped,
} from './ClaimGuaranteeCode';

/**
 * 
 * @export
 * @interface ClaimDto
 */
export interface ClaimDto {
    /**
     * 
     * @type {string}
     * @memberof ClaimDto
     */
    id?: string;
    /**
     * 
     * @type {ClaimGuaranteeCode}
     * @memberof ClaimDto
     */
    guaranteeCode?: ClaimGuaranteeCode;
    /**
     * 
     * @type {number}
     * @memberof ClaimDto
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimDto
     */
    deductible?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimDto
     */
    totalAmount?: number | null;
}



/**
 * Check if a given object implements the ClaimDto interface.
 */
export function instanceOfClaimDto(value: object): value is ClaimDto {
    return true;
}

export function ClaimDtoFromJSON(json: any): ClaimDto {
    return ClaimDtoFromJSONTyped(json, false);
}

export function ClaimDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'guaranteeCode': json['guaranteeCode'] == null ? undefined : ClaimGuaranteeCodeFromJSON(json['guaranteeCode']),
        'count': json['count'] == null ? undefined : json['count'],
        'deductible': json['deductible'] == null ? undefined : json['deductible'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
    };
}

export function ClaimDtoToJSON(json: any): ClaimDto {
    return ClaimDtoToJSONTyped(json, false);
}

export function ClaimDtoToJSONTyped(value?: ClaimDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'guaranteeCode': ClaimGuaranteeCodeToJSON(value['guaranteeCode']),
        'count': value['count'],
        'deductible': value['deductible'],
        'totalAmount': value['totalAmount'],
    };
}

